import { useEffect, useState } from 'react';
import { RefreshCw, X } from 'lucide-react';

export function ServiceWorkerUpdate() {
  const [updateAvailable, setUpdateAvailable] = useState(false);

  useEffect(() => {
    if (!('serviceWorker' in navigator)) return;

    navigator.serviceWorker.register('/sw.js').then((registration) => {
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        if (!newWorker) return;

        newWorker.addEventListener('statechange', () => {
          if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
            // A new version has been installed and the old worker is still controlling pages
            setUpdateAvailable(true);
          }
        });
      });
    });

    // Listen for messages from the SW (e.g., explicit update notification)
    navigator.serviceWorker.addEventListener('message', (event) => {
      if (event.data?.type === 'UPDATE_AVAILABLE') {
        setUpdateAvailable(true);
      }
    });
  }, []);

  const reload = () => {
    window.location.reload();
  };

  const dismiss = () => {
    setUpdateAvailable(false);
  };

  if (!updateAvailable) return null;

  return (
    <div className="fixed bottom-4 right-4 z-[100] max-w-sm bg-slate-900 text-white rounded-xl shadow-lg border border-slate-700 p-4 animate-in slide-in-from-bottom-4">
      <div className="flex items-start gap-3">
        <RefreshCw className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" />
        <div className="flex-1 min-w-0">
          <p className="font-semibold text-sm">Update available</p>
          <p className="text-xs text-slate-300 mt-1">
            A newer version of Sunny 106.5 is ready. Reload to get the latest features and fixes.
          </p>
          <div className="flex items-center gap-2 mt-3">
            <button
              onClick={reload}
              className="px-3 py-1.5 text-xs font-medium bg-primary hover:bg-primary/90 rounded-lg transition-colors"
            >
              Reload now
            </button>
            <button
              onClick={dismiss}
              className="px-3 py-1.5 text-xs font-medium text-slate-300 hover:text-white transition-colors"
            >
              Later
            </button>
          </div>
        </div>
        <button
          onClick={dismiss}
          className="text-slate-400 hover:text-white"
          aria-label="Dismiss update"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
